/** The Nebulize mark. One clipped nebula, dense at the core and dispersing. Inherits currentColor. */

import type { CSSProperties } from "react";

import { cn } from "@/lib/cn";

import "./Logo.css";

export interface LogoProps {
  readonly size?: number;
  /** Draw the wordmark beside the mark. */
  readonly wordmark?: boolean;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function Logo({ size = 26, wordmark = true, className, style }: LogoProps) {
  return (
    <span className={cn("nb-logo", className)} style={style}>
      <svg
        width={size}
        height={size}
        viewBox="-66 -66 132 132"
        role="img"
        aria-label="Nebulize"
        focusable="false"
      >
        <clipPath id="nb-mark-clip">
          <circle r="60" />
        </clipPath>
        <g clipPath="url(#nb-mark-clip)" fill="currentColor">
          <circle cx="-23.0" cy="-79.67" r="7.68" />
          <circle cx="0.0" cy="-79.67" r="3.73" />
          <circle cx="-57.5" cy="-59.76" r="14.18" />
          <circle cx="-34.5" cy="-59.76" r="11.09" />
          <circle cx="-11.5" cy="-59.76" r="6.72" />
          <circle cx="-69.0" cy="-39.84" r="15.43" />
          <circle cx="-46.0" cy="-39.84" r="13.66" />
          <circle cx="-23.0" cy="-39.84" r="10.19" />
          <circle cx="0.0" cy="-39.84" r="5.79" />
          <circle cx="-80.5" cy="-19.92" r="16.03" />
          <circle cx="-57.5" cy="-19.92" r="15.16" />
          <circle cx="-34.5" cy="-19.92" r="13.06" />
          <circle cx="-11.5" cy="-19.92" r="9.23" />
          <circle cx="11.5" cy="-19.92" r="4.92" />
          <circle cx="-69.0" cy="0.0" r="15.9" />
          <circle cx="-46.0" cy="0.0" r="14.84" />
          <circle cx="-23.0" cy="0.0" r="12.36" />
          <circle cx="0.0" cy="0.0" r="8.25" />
          <circle cx="23.0" cy="0.0" r="4.14" />
          <circle cx="-80.5" cy="19.92" r="16.24" />
          <circle cx="-57.5" cy="19.92" r="15.75" />
          <circle cx="-34.5" cy="19.92" r="14.44" />
          <circle cx="-11.5" cy="19.92" r="11.58" />
          <circle cx="11.5" cy="19.92" r="7.27" />
          <circle cx="34.5" cy="19.92" r="3.44" />
          <circle cx="-69.0" cy="39.84" r="16.17" />
          <circle cx="-46.0" cy="39.84" r="15.56" />
          <circle cx="-23.0" cy="39.84" r="13.97" />
          <circle cx="0.0" cy="39.84" r="10.71" />
          <circle cx="23.0" cy="39.84" r="6.31" />
          <circle cx="-57.5" cy="59.76" r="16.09" />
          <circle cx="-34.5" cy="59.76" r="15.32" />
          <circle cx="-11.5" cy="59.76" r="13.42" />
          <circle cx="11.5" cy="59.76" r="9.78" />
          <circle cx="34.5" cy="59.76" r="5.41" />
          <circle cx="-23.0" cy="79.67" r="15.03" />
          <circle cx="0.0" cy="79.67" r="12.77" />
          <circle cx="23.0" cy="79.67" r="8.82" />
        </g>
      </svg>
      {wordmark ? <span className="nb-logo-word">nebulize</span> : null}
    </span>
  );
}
